import { jsxs as x, jsx as e } from "react/jsx-runtime";
import { c as o } from "../clsx-OuTLNxxd.js";
import { forwardRef as m } from "react";
import { B as f } from "../Button-BDQYwrrG.js";
import { A as r, a as b } from "../Avatar-BklEyPdJ.js";
import "../OddsButton.css?__remix_sideEffect__";const z = "320px",H = "600px",u = "1025px",_ = "_isVisuallyHidden_1blz3_52",p = "_oddsButton_1blz3_64",B = "_oddsContainer_1blz3_73",S = "_line_1blz3_81",W = "_odds_1blz3_64",w = "_withLine_1blz3_97",t = {
    mobile: z,
    "mobile-wide": "480px",
    tablet: H,
    "tablet-wide": "800px",
    desktop: u,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: _,
    oddsButton: p,
    oddsContainer: B,
    line: S,
    odds: W,
    withLine: w,
    "direction-row": "_direction-row_1blz3_115"
  },C = m(
    ({
      bookieColour: l,
      bookieLogo: s,
      bookieName: n,
      className: c = "",
      flexDirection: d = "column",
      line: i,
      odds: y,
      selected: a = !1,
      ...g
    }, h) => /* @__PURE__ */x(
      f,
      {
        className: o(t.oddsButton, c),
        variant: a ? "secondary" : "default",
        ref: h,
        ...g,
        title: n,
        children: [
        /* @__PURE__ */e(r, { size: "small", style: { backgroundColor: l }, children: /* @__PURE__ */e(b, { alt: `${n} logo`, src: s }) }),
        /* @__PURE__ */x(
          "div",
          {
            className: o(
              t.oddsContainer,
              t[`direction-${d}`]
            ),
            children: [
            i && /* @__PURE__ */e("span", { className: t.line, children: i }),
            /* @__PURE__ */e("span", { className: o(t.odds, { [t.withLine]: i }), children: y })]

          }
        )]

      }
    )
  );
C.displayName = "OddsButton";
export {
  C as OddsButton };